import Route from 'route-parser'
import { combineLatest } from 'rxjs'
import { map, filter, distinctUntilChanged } from 'rxjs/operators'
import { mergeResponses, isValidResponse, mapResponse } from 'front-end-core/helpers/dataflow'
import { RESPONSE_UNAUTHORIZED, RESPONSE_PENDING, RESPONSE_BADRESPONSE } from 'front-end-core/constants/responses'
import { EMAIL_PREFERENCES, SEARCH_HISTORY, USER, USER_AUTH } from 'constants/requests'
import { URL_SEARCH_HISTORY, URL_PASSWORD_RESET, URL_EMAIL_PREFERENCES } from 'constants/urls'
import { AOL_CORPORATE } from 'constants/aol/aol'
import { DayMap } from 'requests/session/transforms'
import { fetch, observe } from 'services/ApiService'
import observeRequest from 'helpers/fcObserveRequest'

const searchHistoryRoute = new Route(URL_SEARCH_HISTORY)
const passwordResetRoute = new Route(URL_PASSWORD_RESET)

const $user = fetch(USER)

export const User = combineLatest(
  [$user, fetch(USER_AUTH)],
  mergeResponses
)

export const $emailPreferences = fetch(EMAIL_PREFERENCES)

export const $isLogged = $user.pipe(map(x =>
  x === RESPONSE_PENDING
    ? RESPONSE_PENDING
    : x === RESPONSE_UNAUTHORIZED
      ? false
      : isValidResponse(x)
), map(mapResponse(isLogged => ({ isLogged }))))

export const $userAOL = $user.pipe(map(x =>
  x === RESPONSE_PENDING
    ? RESPONSE_PENDING
    : x === RESPONSE_UNAUTHORIZED
      ? AOL_CORPORATE
      : isValidResponse(x)
), map(mapResponse(areaOfLaw => ({ areaOfLaw }))))

export const UserUrn = User.pipe(filter(isValidResponse), map(x => x.uri), distinctUntilChanged())

export const SearchHistory = observe(SEARCH_HISTORY, { length: 20 })

export const pushSearchHistory = (searchTerm, searchType) =>
  observeRequest({
    url: searchHistoryRoute.reverse(),
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    body: JSON.stringify({ searchTerm, searchType })
  }).subscribe()

export const submitPasswordReset = (body) =>
  observeRequest({
    url: passwordResetRoute.reverse(),
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    body: JSON.stringify(body)
  }).pipe(map(resp => ({ success: resp !== RESPONSE_BADRESPONSE })))

export const updateEmailPreferences = (preferences) => {
  const {
    areaOfLaw,
    caEmails: enabled,
    caEmailDays
  } = preferences

  const payload = {
    areaOfLaw,
    enabled,
    ...Object.keys(DayMap).reduce((acc, curr) => ({
      ...acc,
      [curr]: caEmailDays.includes(DayMap[curr])
    }), {})
  }

  return observeRequest({
    url: URL_EMAIL_PREFERENCES,
    headers: { 'Content-Type': 'application/json' },
    method: 'PUT',
    body: JSON.stringify(payload)
  })
}
